export { default as translations } from './translations.json';

export const COMPLETED_TRANSITIONS = [
  'transition/complete',
  'transition/review-1-by-customer',
  'transition/review-1-by-provider',
];

/**
 * Check if a transaction is eligible for a review request.
 * @param {Object} transaction — Sharetribe transaction
 * @returns {boolean}
 */
export const isEligibleForReviewRequest = (transaction) => {
  if (!transaction) return false;
  const { lastTransition, metadata } = transaction.attributes;
  if (metadata?.reviewRequestSentAt) return false;
  return COMPLETED_TRANSITIONS.includes(lastTransition);
};
